/**
 * FM Animations — Scroll Reveal + Gold Shimmer
 * v2 — broadened selectors, runs after full page load
 */
(function() {
  'use strict';

  // Run after everything is loaded (images, iframes, etc.)
  window.addEventListener('load', function() {
    setTimeout(init, 200); // Small delay to ensure theme JS has run
  });

  function init() {
    applyRevealAttributes();
    applyShimmerClass();
    setupIntersectionObserver();
  }

  function applyRevealAttributes() {
    // Broad selectors that target actual rendered elements
    var groups = [
      // Section headers — these contain the heading + tag + view all
      { sel: '.section__header', dir: '' },
      { sel: '.section__heading', dir: '' },

      // Featured collection headings & tags (generated via CSS ::before)
      { sel: '[id*="feat-"] .section__header', dir: '' },

      // Product cards — try multiple selectors
      { sel: '.cc-featured-collection .card--product', dir: '' },
      { sel: '.cc-featured-collection product-card', dir: '' },
      { sel: '.featured-collection-products .card--product', dir: '' },
      { sel: '.slider__grid > li', dir: '' },

      // Custom liquid sections (mosaic, wonder, signup, story)
      { sel: '.fm-cats__header', dir: '' },
      { sel: '.fm-cats__item', dir: '' },
      { sel: '.fm-cats__footer', dir: '' },
      { sel: '.fm-story__tag', dir: 'left' },
      { sel: '.fm-story__title', dir: 'left' },
      { sel: '.fm-story__divider', dir: 'left' },
      { sel: '.fm-story__desc', dir: 'left' },
      { sel: '.fm-story__pillars', dir: 'left' },
      { sel: '.fm-story__btn', dir: 'left' },
      { sel: '.fm-story__media', dir: 'right' },
      { sel: '.fm-story__media-badge', dir: 'scale' },
      { sel: '.fm-wonder__inner', dir: 'left' },
      { sel: '.fm-signup__text', dir: 'left' },
      { sel: '.fm-signup__form', dir: 'right' },

      // Testimonials
      { sel: '.testimonial', dir: '' },
      { sel: '[id*="testimonials"] .section__header', dir: '' },

      // FAQ
      { sel: '.disclosure--row', dir: '' },
      { sel: '[id*="faq"] .reading-width > h2', dir: '' },
      { sel: '[id*="faq"] .reading-width > h3', dir: '' },

      // Footer
      { sel: '.footer-col', dir: '' },

      // Media with text
      { sel: '.media-with-text__text', dir: 'left' },
      { sel: '.media-with-text__media', dir: 'right' },

      // Collection list cards
      { sel: '.collection-card', dir: '' },

      // Generic cards
      { sel: '.card--product', dir: '' }
    ];

    groups.forEach(function(group) {
      var elements = document.querySelectorAll(group.sel);
      var siblingCount = 0;
      var lastParent = null;

      elements.forEach(function(el) {
        if (el.hasAttribute('data-fm-reveal')) return;
        // Skip elements already visible above the fold
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85 && rect.top > 0) {
          // Above fold — reveal immediately with no animation
          el.style.opacity = '1';
          return;
        }

        el.setAttribute('data-fm-reveal', group.dir);

        // Stagger siblings
        var parent = el.parentElement;
        if (parent === lastParent) {
          siblingCount = Math.min(siblingCount + 1, 8);
        } else {
          siblingCount = 0;
          lastParent = parent;
        }
        if (siblingCount > 0) {
          el.setAttribute('data-fm-delay', siblingCount);
        }
      });
    });
  }

  function applyShimmerClass() {
    var sels = [
      '.fm-hero__btn',
      '.fm-story__btn',
      '.fm-wonder__btn',
      '.fm-signup__submit',
      '.fm-cats__viewall',
      '.btn--primary',
      '.section__header a.link',
      '.section__heading-link',
      '.fm-card-pill',
      '.fm-cats__circle',
      '.footer-block__heading',
      '.card--product .card__image-wrapper',
      'product-card .card__image-wrapper'
    ];

    sels.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (!el.classList.contains('fm-shimmer')) {
          el.classList.add('fm-shimmer');
        }
      });
    });
  }

  function setupIntersectionObserver() {
    var els = document.querySelectorAll('[data-fm-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -30px 0px'
    });

    els.forEach(function(el) { observer.observe(el); });
  }
})();
